import colors from "core/resources/theme/colors";
import { applyPrecision } from "infra/helpers/applyPrecision";
import React from "react";
import { PieChart } from "react-minimal-pie-chart";

interface FracaoChartProps {
  sumValues: number;
  remainingValue: number;
}

function FracaoChart({ sumValues, remainingValue }: FracaoChartProps) {
  return (
    <PieChart
      lineWidth={40}
      data={[
        { title: "Soma", value: sumValues, color: colors.primary },
        {
          title: "Restam",
          value: remainingValue,
          color: remainingValue >= 0 ? colors.gray : colors.red,
        },
      ]}
      style={{ overflow: "visible" }}
      labelPosition={110}
      label={({ dataEntry, x, y, dx, dy }) => (
        <g>
          <circle
            x={x}
            y={y}
            cx={x + dx}
            cy={y + dy}
            r="14"
            stroke="#ffffff"
            fill="#ffffff"
          />
          <text
            x={x}
            y={y + 3}
            dx={dx}
            dy={dy}
            stroke="#181414"
            textAnchor="middle"
            fontFamily="Poppins"
            fontSize="9"
            strokeWidth="1"
            fill="#000000"
          >
            {applyPrecision(
              Number.isFinite(dataEntry?.value) ? dataEntry?.value : 0,
              5
            )}
            %
          </text>
        </g>
      )}
      labelStyle={{
        backgroundColor: colors.white,
        padding: 16,
        borderRadius: 999,
      }}
    />
  );
}

export default FracaoChart;
